import React from "react";
import { CheckCircle2, Loader2, X } from "lucide-react";
import { formatTax } from "./configHelpers";

export default function GstEditModal({
  open,
  gstForm,
  setGstForm,
  halfTax,
  isSavingGst,
  onClose,
  onSubmit,
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-3">
      <div className="relative w-full max-w-lg rounded-2xl bg-white p-6 shadow-xl">
        <div className="mb-5 flex items-center justify-between">
          <div>
            <h3 className="text-lg font-bold">Edit GST Details</h3>
            <p className="text-xs text-gray-500">
              Enter total GST only. SGST/CGST will be shown half-half.
            </p>
          </div>

          <button onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="md:col-span-2">
            <label className="mb-1 block text-xs font-semibold text-gray-500">
              GST No.
            </label>
            <input
              type="text"
              placeholder="Enter GST number"
              value={gstForm.gst}
              onChange={(e) =>
                setGstForm((prev) => ({
                  ...prev,
                  gst: e.target.value.toUpperCase(),
                }))
              }
              className="w-full rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:border-[#075E54] focus:outline-none"
            />
          </div>

          <div>
            <label className="mb-1 block text-xs font-semibold text-gray-500">
              GST Type
            </label>
            <select
              value={gstForm.gstType}
              onChange={(e) =>
                setGstForm((prev) => ({
                  ...prev,
                  gstType: e.target.value,
                }))
              }
              className="w-full rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:border-[#075E54] focus:outline-none"
            >
              <option value="incl">Incl</option>
              <option value="excl">Excl</option>
            </select>
          </div>

          <div>
            <label className="mb-1 block text-xs font-semibold text-gray-500">
              Total GST %
            </label>
            <input
              type="number"
              step="0.01"
              min="0"
              placeholder="Example: 5.00"
              value={gstForm.taxGst}
              onChange={(e) =>
                setGstForm((prev) => ({
                  ...prev,
                  taxGst: e.target.value,
                }))
              }
              className="w-full rounded-xl border border-gray-300 px-4 py-2.5 text-sm focus:border-[#075E54] focus:outline-none"
            />
          </div>

          <div className="rounded-xl border bg-gray-50 px-4 py-3">
            <div className="text-xs font-semibold text-gray-500">SGST</div>
            <div className="mt-1 text-lg font-bold text-gray-900">
              {formatTax(halfTax)}%
            </div>
          </div>

          <div className="rounded-xl border bg-gray-50 px-4 py-3">
            <div className="text-xs font-semibold text-gray-500">CGST</div>
            <div className="mt-1 text-lg font-bold text-gray-900">
              {formatTax(halfTax)}%
            </div>
          </div>
        </div>

        <div className="mt-6 flex justify-end gap-2">
          <button
            onClick={onClose}
            className="rounded-xl border px-5 py-2.5 text-sm font-semibold hover:bg-gray-50"
          >
            Cancel
          </button>

          <button
            onClick={onSubmit}
            disabled={isSavingGst}
            className="inline-flex items-center gap-2 rounded-xl bg-[#075E54] px-5 py-2.5 text-sm font-semibold text-white hover:opacity-90 disabled:opacity-60"
          >
            {isSavingGst ? (
              <Loader2 size={16} className="animate-spin" />
            ) : (
              <CheckCircle2 size={16} />
            )}
            {isSavingGst ? "Saving..." : "Update GST"}
          </button>
        </div>
      </div>
    </div>
  );
}